import React from 'react'
import Helmet from 'react-helmet'
import 'react-toastify/dist/ReactToastify.min.css'
import { ToastContainer } from 'react-toastify'
import { createGlobalStyle } from 'styled-components'
import { device } from '../Breakpoints'
import { colors } from '../Colors'
import Header from '../Header'
import Footer from '../Footer'
import favicon from '../../img/favicon.ico'
import arrow from '../../icons/arrow-select.svg'
import chevronRight from '../../icons/icon-chevron-right.svg'
import chevronLeft from '../../icons/icon-chevron-left.svg'

const GlobalStyle = createGlobalStyle`
  body {
    /*max-width:1920px;*/
    margin:auto;
    font-size:20px;
    font-family: 'Santral', Arial, Helvetica, sans-serif;
    font-weight: 500;
    padding:0;
    background: #F9F9F7;
    overflow-x:hidden;
    color: ${colors.cinza};
    -webkit-font-smoothing: antialiased;
    -webkit-text-shadow: rgba(0,0,0,.01) 0 0 1px;
    text-shadow: rgba(0,0,0,.01) 0 0 1px;
    h1, h2, h3, p {
      margin-top:0;
    }
    a{      
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
    p{
      font-size: 18px!important;
      line-height: 30px!important;
      margin-bottom: 1.4em;
      overflow-wrap: break-word;
      word-wrap: break-word;
      @media ${device.mobileL} {
        font-size: 16px!important;
        line-height: 1.5em!important;
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
         line-height: 1.8em!important;
        }
    }
    *:focus{
      outline: none;
    }
    .inner ul, .center ul, .inner ol, .center ol {
      font-size: 18px!important;
      line-height: 30px!important;
      margin-bottom: 1.4em;
      @media ${device.mobileL} {
        font-size: 16px!important;
        line-height: 1.5em!important;
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
     font-size: 19px!important;
         line-height: 1.9em!important;
        }
    }
    
    .inner ul, .center ul, .inner ol, .center ol {
      li {
        margin-bottom: 20px;
      }
    }
    .center ul.posts .categories , .center ul.materiais .tipo {
      line-height: auto!important;
    }
    .center p:last-child, .inner p:last-child{
      margin-bottom:0;
    }
    .center ol{
      padding: 0 20px;
    }
    h1{
      font-size:2.2em!important;
      font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
      font-weight: bold;
      @media ${device.mobileL} {
        font-size: 22px!important;
      }
    }
    .center h2{
      font-size:2.2em!important;
      font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
      font-weight: bold;
      @media ${device.mobileL} {
        font-size: 22px!important;
      }
    }
    h3{
      font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
      font-size:1.7em;
      @media ${device.mobileL} {
        font-size: 22px!important;
      }
    }
    h4{
      font-weight: bold;
    }
    .main {
      display:flex;
      width:100%;
      flex-wrap: wrap;
      min-width:100%;
      justify-content:center;
      overflow: hidden;
      @media ${device.minLaptop} {
        padding-top: 135px; 
      }
      @media ${device.mobileL} {
        padding-top: 0px; 
      }
      
     
      .carousel-root{
        .control-arrow{
          padding:0;
          opacity: 0.6;
          :before{
            padding: 20px;
            margin:0;
            border:0;
          }
          :hover{
            background:none;
            opacity: 1;
          }
         
        }
        .control-prev{
          :before{
            background:url(${chevronLeft}) no-repeat ${colors.lilas};            
            background-position: center;
          }
        }
        .control-next{
          :before{
            background:url(${chevronRight}) no-repeat ${colors.lilas};
            background-position: center;
            }
        }
        .control-dots,.carousel-status{
          display: none;
        }
        .thumbs-wrapper{
          .control-arrow{
            display:none;
          }
        }
        .thumbs{
          text-align: center;
          padding:0;
          .thumb{
            border: none;
          }
          .thumb.selected{
            border:3px solid #fff;
          }
        }
        .slide{
          background:none;
          p{
            text-align:center;
          }
        }
      }
      .inner {
        @media ${device.mobileL} {
          > div{
            width:100%;
          }
        }
      }
     div[tabindex] {
        width: 100%;
      }
       .inner {
      .slick-slider{
          div[tabindex] {
            width: auto!important;
          }
          } 
      } /**/
    }
    input.error, textarea.error, select.error {
      border: 1px solid red!important;
    }
    button.button, a.button {
    border: none;
    border-radius: 25px;
    margin: 10px 0px;
    height: 45px;
    width: 170px;
    color: white;
    text-transform: uppercase;
    background: ${colors.inputGradiente};
    font-family: 'Santral', Arial, Helvetica, sans-serif;
    margin-top: 10px;
    cursor: pointer;
    :hover {
      background: ${colors.verdeGradienteReverso};
    }
    
    @media ${device.tablet} {
      padding: 0;
      margin: 10px 5px 0;
      text-align: center;
    }
  }
  button.prev, a.prev{
      background: ${colors.laranjaGradiente};
      :hover{
        background: ${colors.laranjaGradienteReverso};
      }
    }
    button.next, a.next{
      background: ${colors.verdeGradienteReverso};
      :hover{
        background: ${colors.verdeGradiente};
      }
    }
    .ReactModal__Overlay {
    z-index: 9999 !important;
    button{
      background: none;
      border: none;
      color: #000000;
      font-size: 1.2em;
      cursor: pointer;
      position:absolute;
      top:10px;
      right:10px;
    }
  }
  div.center, section.center {
    max-width: 1114px;
    margin: auto;
    padding: 0 0px;
    box-sizing: border-box;
    @media ${device.mobileL} {
      max-width: 100%;
      padding: 0;
    }
  }
  strong {
    font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
    font-weight: 700;
  }

  select{
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: url(${arrow});
    background-repeat: no-repeat, repeat;
    background-position: right;
    background-size: contain;
    cursor: pointer;
  }
}

@media ${device.mobileL} {
  .offsetImgStart {
      margin: -14% -20% 10% !important;
      width: 137% !important;
    }
  .offsetImgMid {
      margin: 0% -20% 10% !important;
      width: 137% !important;
    }
  .offsetImgEnd {
      margin: 0 -20% -17% !important;
      width: 137% !important;
  }
  .offsetImgEnd2 {
      margin: 10% -20% 0% !important;
      width: 137% !important;
    }
  .offsetImgEnd3 {
      margin: 0% -20% 10% !important;
      width: 137% !important;
    }
  }
.noPadding {
    padding: 0;
  }
.accordion {
  margin-top:2em;
}
.hideMobile{
  @media ${device.mobileL} {
     display: none;
    }
}
.accordion__item {  
  box-shadow: 0px 4px 8px 2px rgba(0,0,0,0.2);
}
.accordion__heading {
      text-align: left;
      .accordion__button {
        padding: 0;
        background: #ffffff;        
        color: #FA7373;
        position: relative;
        overflow: hidden;   
        display:flex;
        justify-content: space-between;
        width:100%;
        :after {
          content: "+";
          display:flex;
          align-items: center;
          background: #FED5D5;
          padding:0.1em 0.5em;
          font-size: 67px;
          font-family: "Santral Light", Arial, Helvetica, sans-serif;
          color: #793939;
          -webkit-transition: -webkit-transform .8s ease-in-out;
          -ms-transition: -ms-transform .8s ease-in-out;
          transition: transform .3s ease-in-out; 
          @media ${device.mobileL} {
            font-size: 44px;
          }
          }
        h3 { 
          margin: 0;
          font-size: 1em!important;
          padding: 2em;
          position: relative;
          max-width: 960px;
          :before {
            position: absolute;
            content: '';
            top: 24px;
            left: 38px;
            border: 1px solid #FA7373;
            width: 5%;
            opacity: 0.5;
            @media ${device.mobileL} {
              top: 16px;
            left: 28px;
          }
          }
          :after {
            position: absolute;
            content: '';
            bottom: 24px;
            left: 38px;
            border: 1px solid #FA7373;
            width: 5%;
            opacity: 0.5; 
            @media ${device.mobileL} {
              bottom: 16px;
            left: 28px;
          }
          }
        }
        :hover {
          cursor: pointer;
          background: #793939;
          color: #ffffff;
          :after{
            background: #793939;
            color: #ffffff;
          }
          h3{
            :before {
            border: 1px solid #fff;
            }
            :after {
              border: 1px solid #fff;
            }
          }
        }
        @media ${device.mobileL} {
          font-size: 0.7em;
        }
      }
      .accordion__button[aria-expanded="true"]{
        background-color: #793939;
        color: #ffffff;
        :after {
          transform: rotate(-45deg);
          background-color: #793939;
          color: #ffffff;
        }
        h3 { 
          :before {          
            border-top: 1px solid #ffffff;
          }
          :after {
            border-bottom: 1px solid #ffffff;
          }
        }
      }
    }
    .accordion__item {
      margin-bottom: 20px;
    }
    .accordion__panel {
      font-size: 0.8em;
      line-height: 1.6em;
      background: #ffffff;
      margin-bottom: 20px;
      .resposta {
        display: flex;
        padding: 30px;
        p {
          padding-left: 10px;
          margin: 0;
          color: ${colors.cinza};
          @media ${device.mobileL} {
            padding: 0 10px;
          }
        }
        img {
          width: 35px;
          @media ${device.mobileL} {
            padding-top: 10px;
          }
        }
      }
      .resposta2 {
        display: flex;
        overflow: hidden;
        p {
          padding: 30px;
          margin: 0;
          color: #000000;
          @media ${device.mobileL} {
            padding: 2em;
          }
        }
        img {
          height:100%;
          @media ${device.mobileL} {
            width: 100%;
          }
        }
        @media ${device.mobileL} {
          display: inline;
        }
      }
      @media ${device.mobileL} {
        font-size: 0.8em;
        text-justify: left;
      }
    }
`
const TemplateWrapper = ({
  children,
  title = 'Hospital e Maternidade Santa Joana',
  description = '',
  search = false,
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="shortcut icon" href={favicon} type="image/x-icon" />
        <link rel="icon" href={favicon} type="image/x-icon" />
      </Helmet>
      <GlobalStyle />
      <Header search={search} />
      <ToastContainer limit={1} />
      <div className="main">{children}</div>
      <Footer />
    </>
  )
}

export default TemplateWrapper
